<template>
  <div class="blog">
    <van-list v-model="loading" :finished="finished" @load="loadMore">
      <div class="list">
        <BlogItem v-for='(item, index) in list' :key='index' :info='item' :user='localuser' :newtoken='newtoken' @deleteBlog='deleteBlog'></BlogItem>
      </div>
    </van-list>
    <!-- <img class="editbtn" src='./image/icon_fabu.png' @click='publish'/> -->
    <div class="navbtn fabt" @click='publish'>发帖</div>
    <div class="navbtn dkxd" @click='dkeou'>下单</div>
    <div class="navbtn editbtn" @click='editbtn'>导航</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BlogItem from './child/BlogItem';
import { Toast } from 'vant';
import $ from 'jquery';

export default {
  data() {
    return {
      postId: '',
      user: {},
      list: [],
      condition: {
        currPage: 1,
        pageRows: 10,
      },
      total: 0,
      loading: false,
      finished: false,
      duration: 1500,
      newtoken:'',
    };
  },
  methods: {

    loadMore() {
      if (this.list.length >= this.total) {
        return;
      }
      this.loading = true;
      this.condition.currPage++;
      this.getBligList();
    },

    getBligList() {
      this.$http.post(`${this.URL_PREFIX}/app/get/bbs/post/list/bySiteId`, {
        ...this.condition,
        siteId: location.href.split('siteId=')[1],
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.total = res.resData.pageInfo ? res.resData.pageInfo.total : 0;
          const tempArr = res.resData.pageList ? res.resData.pageList : [];
          this.list = this.list.concat(tempArr);
          this.finished = this.list.length >= this.total ? true : false;
          this.newtoken = res.resData.token;
          localStorage.setItem('swtoken',res.resData.token)
        }else{
          this.$toast(res.resDesc);
        }
        this.loading = false;
      });
    },
    editbtn(e) {
        e.preventDefault();
        var flag = $(".fabt").is(":hidden");
        if(flag){
            $(".fabt").show().animate({'bottom':'1.6333333rem','right':'3.0333333rem'});
            $(".dkxd").show().animate({'bottom':'3.0333333rem','right':'1.6333333rem'});
        }else{
            $(".fabt").animate({'bottom':'1.333333rem','right':'1.333333rem'},function(){
              $(".fabt").fadeOut()
            });
            $(".dkxd").animate({'bottom':'1.333333rem','right':'1.333333rem'},function(){
              $(".dkxd").fadeOut()
            });
        }
    },
    // 发表
    publish(){
      this.$router.push('/bbs/publish?siteId='+location.href.split('siteId=')[1]);
    },
    dkeou(){
      this.$router.push('/bbs/dkeou');
    },
    // 删除
    deleteBlog(id) {
      const index = this.list.findIndex((item) => {
        return item.id === id;
      });
      this.list.splice(index, 1);
    },
  },
  computed: {
    ...mapGetters(['currentParkId', 'token', 'localuser']),
  },
  components: { BlogItem },
  created() {
    this.getBligList();
    console.log($)
  },
};
</script>


<style lang="scss" scoped>
@import '~@scss';
.blog{
  
  .list{
    padding: .32rem;
  }
  .editbtn{
    display: block;
    position: fixed;
    right: 1.333333rem;
    bottom: 1.333333rem;
    width: 1.333333rem;
    height: 1.333333rem;
    border-radius: 50%;
  }
  .navbtn{
    display: block;
    position: fixed;
    right: 1.333333rem;
    bottom: 1.333333rem;
    width: 1.333333rem;
    height: 1.333333rem;
    border-radius: 50%;
    background: red;
    color: #fff;
    text-align: center;
    line-height: 1.333333rem;
    font-size: 0.36rem;
  }
  .fabt{
    display: none;
  }
  .dkxd{
    display: none;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/bbs/components/BlogList.vue